import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IProductColor } from "../../interfaces/IProduct";
import _, { set } from "lodash";
import { getProductColors, getProductDetails } from "../../api/editor.api";
import {
  getCatalogProductOptions,
  getCataProduct,
  getCataProductImages,
} from "../../../api/catalog_product.api";

const initialState: any = {
  product_data: null,
  product_details: null,
  loading: false,
  selected_color: null,
  product_images: [],
  product_colors: {
    catalogproductoptions: [],
    catalogproductvariants: [],
  },
  product_basic_details: null,
  current_design_data: null,
  selected_variant_data: [],
  default_variant: null,
  imageQuality: 50,
  imageSize: 800,
  format: "jpeg",
  product_title: "",
  refresher: false,
  totalSelectedQuantity: 0,
};

export const fetchProductColors = createAsyncThunk(
  "product/fetchProductColors",
  async (payload: any, { dispatch }) =>
    getProductColors().then((res) => {
      return res;
    })
);
export const fetchProductDetails = createAsyncThunk(
  "product/fetchProductDetails",
  async (payload: any, { dispatch }) =>
    getCataProduct(payload.productId).then((res) => {
      return res;
    })
);
export const fetchProductImages = createAsyncThunk(
  "product/fetchProductImages",
  async (payload: any, { dispatch }) =>
    getCataProductImages(payload.productId).then((res) => {
      return res;
    })
);
export const fetchProductCatalogColors = createAsyncThunk(
  "product/fetchProductCatalogColors",
  async (payload: any, { dispatch }) =>
    getCatalogProductOptions(payload.productId).then((res) => {
      return res;
    })
);
const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setNewProductColor: (state, action: PayloadAction<any>) => {
      const selectedColor = state.product_data.colors.find(
        (data: IProductColor) => data.variant_id == action.payload
      );
      state.selected_color = selectedColor;
    },
    setDesignDataGlobally: (state, action: PayloadAction<any>) => {
      state.current_design_data = action.payload;
    },
    setProductVariants: (state, action: PayloadAction<any>) => {
      state.selected_variant_data = action.payload;
    },
    setSeletedProductVariants: (state, action: PayloadAction<any>) => {
      state.selected_product_variant_data = action.payload;
    },
    setSelectDefaultVariant: (state, action: PayloadAction<any>) => {
      state.default_variant = action.payload;
    },
    setImageQuality: (state, action: PayloadAction<any>) => {
      state.imageQuality = action.payload;
    },
    setImageSize: (state, action: PayloadAction<any>) => {
      state.imageSize = action.payload;
    },
    setFormat: (state, action: PayloadAction<any>) => {
      state.format = action.payload;
    },
    setProductTitle: (state, action: PayloadAction<any>) => {
      state.product_title = action.payload;
    },

    setRefresher: (state, action: PayloadAction<any>) => {
      state.refresher = action.payload;
    },
    setTotalSelectedQuantity: (state, action: PayloadAction<any>) => {
      state.totalSelectedQuantity = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchProductColors.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchProductColors.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(fetchProductDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchProductColors.fulfilled, (state, action) => {
      state.product_data = action.payload;
      state.selected_color = action.payload.colors[0];
      state.loading = false;
    });

    builder.addCase(fetchProductImages.fulfilled, (state, action) => {
      state.product_images = action.payload;

      state.loading = false;
    });
    builder.addCase(fetchProductDetails.fulfilled, (state, action) => {
      state.product_details = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchProductCatalogColors.fulfilled, (state, action) => {
      // debugger;
      state.product_basic_details = {};
      state.product_basic_details["title"] = action.payload.data.title;
      state.product_basic_details["body_html"] = action.payload.data.body_html;
      state.product_basic_details["productName"] =
        action.payload.data.productName;
      state.product_basic_details["product_type"] =
        action.payload.data.product_type;
      state.product_basic_details["productImage"] =
        action.payload.data.productImage;
      state.product_basic_details = { ...action.payload.data };

      state.product_colors = {};
      state.product_colors.catalogproductvariants =
        action.payload.data.CustomizedProductVariants;
      state.product_colors.catalogproductoptions = [
        {
          Name: "Color",
          optionId: "1",
          catalogoptionsvalues: action.payload.data.CustomizedProductoptions,
        },
      ];
      state.loading = false;
    });
  },
});
export const {
  setNewProductColor,
  setDesignDataGlobally,
  setProductVariants,
  setSelectDefaultVariant,
  setImageQuality,
  setImageSize,
  setFormat,
  setProductTitle,
  setSeletedProductVariants,
  setRefresher,
  setTotalSelectedQuantity,
} = productSlice.actions;
export default productSlice.reducer;
